export default __webpack_public_path__ + "images/8a200d8674135cb29fc19e0e1cec6bfc.jpg";